import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

$('.js-form-common').submit(async function (e) {
    e.preventDefault();
    const $button = $(this).find('[type="submit"]');
    const text = $button.text().trim();
    const textProgress = $button.attr('data-progress') ? $button.attr('data-progress').trim() : 'Загрузка...';
    $button.text(textProgress);

    const data = $(this).serializeObject();
    const method = $(this).attr('method').toLowerCase();
    const action = $(this).attr('action');

    const response = await Api[method](action, data);

    $button.text(text);

    if (response.isError) {
        Popup.showContent('Ошибка', response.error, 700, true);
    }
});
